import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=30fc8d16&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=30fc8d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fc8d16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/.jenkins/workspace/crm-ui/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30fc8d16')) {
      api.createRecord('30fc8d16', component.options)
    } else {
      api.reload('30fc8d16', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=30fc8d16&scoped=true&", function () {
      api.rerender('30fc8d16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/order/returnGoodsOrder/edit.vue"
export default component.exports